/**
 * Configuración de la firma electrónica.
 *
 * Producción: integrará Google Workspace SSO con `prompt=reauth` para las
 * operaciones GxP críticas (deuda documentada en Handoff técnico). Por ahora
 * el flag controla si abrimos el modal completo (password + significado +
 * razón) o solo el modal de razón cuando aplica override de defaults.
 */
export const FIRMA_ELECTRONICA_ENABLED = false;

/**
 * Significados estándar de la firma según 21 CFR Part 11 §11.50(a)(2).
 * Cada acción crítica DEBE registrar uno de estos significados.
 */
export const SIGNIFICADOS_FIRMA = [
  'Confirmo que la información es correcta',
  'Apruebo esta operación',
  'Doy mi conformidad regulatoria',
  'Autorizado como responsable técnico',
] as const;

export type SignificadoFirma = (typeof SIGNIFICADOS_FIRMA)[number];
